import moment from "moment";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess } from "utils/Constant";

export const checkRole = (user_role = "", role = "") => {
   const userRole = user_role?.toLowerCase();
   return userRole === role
}

export const RoundTwoDecimals = (number = 0) => {
   return Math.round(number);
};

export const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
export const decimal = num => num.toString().replace(/[^0-9.]/g, "");

export const money = event => {
   return (addCommas(removeNonNumeric(event)))
}

export const GetStatus = e => {
   let status = ""

   if (e === "1"){
      status = "Active"
   }else if(e === "2"){
      status = "Deleted"
   }else if(e === "3"){
      status = "Pending"
   }else if(e === "4"){
      status = ""
   }else{
      status = ""
   }

   return status
}

export const GetBookingStatus = e => {
   let bookingStatus = ""

   if (e === "1"){
      bookingStatus = "Active"
   }else if(e === "2"){
      bookingStatus = "Complete"
   }else if(e === "3"){
      bookingStatus = "Cancelled"
   }else if(e === "4"){
      bookingStatus = ""
   }else{
      bookingStatus = ""
   }

   return bookingStatus
}
export const GetBookingType = e => {
   let bookingType = ""

   if (e === "1"){
      bookingType = "Daily"
   }else if(e === "2"){
      bookingType = "Weekly"
   }else if(e === "3"){
      bookingType = "Monthly"
   }else if(e === "4"){
      bookingType = "Yearly"
   }else{
      bookingType = ""
   }

   return bookingType
}
export const GetPaymentType = e => {
   let paymentType = ""

   if (e === "1"){
      paymentType = "Deposit"
   }else if(e === "2"){
      paymentType = "Rent"
   }else{
      paymentType = ""
   }

   return paymentType
}
export const GetMonth = e => {
   let month = ""

   if (e === "1"){
      month = "January"
   }else if(e === "2"){
      month = "February"
   }else if(e === "3"){
      month = "March"
   }else if(e === "4"){
      month = "April"
   }else if(e === "5"){
      month = "May"
   }else if(e === "6"){
      month = "June"
   }else if(e === "7"){
      month = "July"
   }else if(e === "8"){
      month = "August"
   }else if(e === "9"){
      month = "September"
   }else if(e === "10"){
      month = "October"
   }else if(e === "11"){
      month = "November"
   }else if(e === "12"){
      month = "December"
   }else{
      month = ""
   }

   return month
}
export const GetExpenseCategory = e => {
   let expenseCategory = ""

   if (e === "1"){
      expenseCategory = "Household"
   }else if(e === "2"){
      expenseCategory = "Human Resource"
   }else{
      expenseCategory = ""
   }

   return expenseCategory
}
export const GetDepositStatus = e => {
   let depositStatus = ""

   if (e === "0"){
      depositStatus = "On Hold"
   }else if(e === "1"){
      depositStatus = "Returned"
   }else if(e === "2"){
      depositStatus = "Owned"
   }else{
      depositStatus = ""
   }

   return depositStatus
}
export const GetGender = e => {
   let gender = ""

   if (e === "0"){
      gender = "On"
   }else if(e === "1"){
      gender = "Male"
   }else if(e === "2"){
      gender = "Female"
   }else{
      gender = ""
   }

   return gender
}
export const GetVehicle = e => {
   let vehicle = ""

   if (e === ""){
      vehicle = "No Vehicle"
   }else if(e === "1"){
      vehicle = "Motorcycle"
   }else if(e === "2"){
      vehicle = "Car"
   }else{
      vehicle = "No Vehicle"
   }

   return vehicle
}

export const addSpaceEvery4 = (value) => value.replace(/\s+/g, '').replace(/(.{4})/g, '$1 ').trim();

export const CheckResponse = (response) => {
	if(response.status === ApiResponseSuccess){
		return true
	}else if(response.status === ApiResponseStatusUnauthorized){
		window.location.href = "/login"
	}else{
		return false
	}
}

// DATE
export const NumDate = (value) => {
   return moment(value).format('DD/MM/YYYY')
}
export const ShortDate = (value) => {
   return moment(value).format('DD MMM YYYY')
}
export const LongDate = (value) => {
   return moment(value).format('DD MMMM YYYY')
}